import { Component, Vue, Prop} from 'vue-property-decorator'

import {
    IotMetricsServiceProxy,
    OverDateCountDto,
    OverDateVo
} from '@/service-proxies/app-v2/iot-console.service-proxies'

import './DailyOnline.less';
import dayjs from 'dayjs'
@Component
export default class OverDateCount extends Vue {

    iotMetricsProxy = new IotMetricsServiceProxy();

    title = '';
    selectTenantId = undefined;
    gatewayList=[];

    dateType = 1;

    option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            data: []
        },
        yAxis: {
            type: 'category',
            data: []
        },
        series: [
            {
                data: [],
                label: {
                    show: true
                },
                type: 'bar'
            }
        ]
    };

    data: OverDateCountDto[]=[];

    chart=undefined;

    gatewayListColumns = [
        {
            title: '网关编号',
            dataIndex: 'gatewayCode',
            width: 80,
            ellipsis: true
        }, {
            title: '最后上线时间',
            dataIndex: 'lastOfflineTime',
            width: 80,
            ellipsis: true,
            customRender: (time) => time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : ''
        }
    ]

    mounted() {
        this.chart = (this as any).$echarts.init(
            this.$refs.chart
        );
        this.chart.setOption(this.option);
        this.chart.on('click', (params)=>{
            const d = this.sortData[params.dataIndex];
            this.title = d.tenantName;
            this.selectTenantId=d.tenantId;
            this.getGatewayList();
        })
        this.initData();
    }

    initData(){
        this.gatewayList=[];
        const input = new OverDateVo();
        input.type = this.dateType;

        this.iotMetricsProxy.overDateCount(input)
            .then(res=>{
                this.data=res;
                this.chart.setOption(this.chartOption());
                if(this.data.length>0){
                    this.selectTenantId=this.sortData[this.data.length-1].tenantId;
                    this.title=this.sortData[this.data.length-1].tenantName;
                    this.getGatewayList();
                }
            });
    }

    getGatewayList(){
        const input = new OverDateVo();
        input.type=this.dateType;
        input.tenantId= this.selectTenantId;
        this.iotMetricsProxy.findOverDateGatewayList(input)
            .then(res=>{
                this.gatewayList= res;
            });
    }

    get sortData(){
        return this.data.sort((a,b)=>
            parseInt(a.count) -parseInt(b.count));
    }

    chartOption(){
        return {
            xAxis: {
                data: this.sortData.map(c=>c.tenantName)
            },
            yAxis: {
                data: this.sortData.map(c=>c.tenantName)
            },
            series: [
                {
                    data: this.sortData.map(c=>c.count)
                }
            ]
        };
    }

    dateTypeChange(){
        this.initData();
    }


    handleOpenChange(open) {
        if (!open) {
            this.initData();
        }
    }

    render() {
        return (
            <a-card class="iot-chart" title="网关未登录统计" style="width: 100%;">
                <template slot="extra">
                    <a-radio-group size="small"
                                   v-model={this.dateType}
                                   button-style="solid"
                                   onChange={this.dateTypeChange}
                    >
                        <a-radio-button value={1}>
                            超一周
                        </a-radio-button>
                        <a-radio-button value={2}>
                            超一月
                        </a-radio-button>
                        <a-radio-button value={3}>
                            超三月
                        </a-radio-button>
                    </a-radio-group>
                </template>
                <a-row>
                    <a-col span="18">
                        <div ref="chart" style="width:100%;height:450px"></div>
                    </a-col>
                    <a-col span="6">
                        <h4 class="rankingTitle">
                            {this.title}
                        </h4>
                        <ml-table
                            columns={this.gatewayListColumns}
                            dataSource={this.gatewayList}
                            canChangeColWidth={true}
                            scroll={{ y: 400, x: 160 }}
                            pagination={{
                                pageSize: 8,
                                size: 'small'
                            }}
                        >
                        </ml-table>
                        {/**/}
                        {/*<ul class="rankingList">
                            {
                                this.sortData.map((item,i)=>{
                                    return (<li>
                                        <span class={`rankingItemNumber ${i<3?'active':''}`}>{i+1}</span>
                                        <span class="rankingItemTitle">{item.key}</span>
                                        <span class="rankingItemValue">{item.value}</span>
                                    </li>);
                                })
                            }

                        </ul>*/}
                    </a-col>
                </a-row>

            </a-card>
        )
    }
}
